<app-shared-modal
  [name]="
    shareEmails
      ? 'Email Blast My Marketplace'
      : shareSMS
      ? 'SMS Blast My Marketplace'
      : 'Share My Marketplace'
  "
  [open]="open"
  (modalClose)="handleClose.emit()"
  size="small"
>
  <div class="modal-content">
    <div *ngIf="!organization?.shortName">
      Oops! Something went wrong while loading your organization. Please verify
      your organization details and try again in a few minutes. If the issue
      persists, contact us at
      <a href="mailto:help@rebuilt.com">{{ 'help@rebuilt.com' }}</a
      >.
    </div>

    <div *ngIf="!!organization && !!organization?.shortName">
      <div>
        <span class="font-medium">Your organization:</span>
        {{ organization.name }}.
      </div>

      <ng-container *ngIf="!shareEmails && !shareSMS">
        <div class="icons">
          <a class="item" (click)="shareFacebook()">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-facebook.png"
                alt="Facebook share"
              />
            </div>
            <span>Facebook</span>
          </a>
          <a class="item" (click)="shareEmails = true">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-email.png"
                alt="Email share"
              />
            </div>
            <span>Email Blast</span>
          </a>
          <a
            class="item"
            target="_blank"
            [href]="'https://web.whatsapp.com/send?text=' + shareContent"
          >
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-whatsapp.png"
                alt="Whatsapp share"
              />
            </div>
            <span>WhatsApp</span>
          </a>
          <a
            class="item"
            target="_blank"
            [href]="'https://twitter.com/intent/tweet?text=' + shareContent"
          >
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-x.png"
                alt="X share"
              />
            </div>
            <span>X</span>
          </a>
          <a class="item" (click)="shareSMS = true">
            <div class="icon">
              <img
                src="/assets/images/social-icons/social-sms.png"
                alt="X share"
                class="sms"
              />
            </div>
            <span>SMS Blast</span>
          </a>
        </div>
        <app-organization-share-copy-link [orgUrl]="orgUrl">
        </app-organization-share-copy-link>
      </ng-container>

      <ng-container *ngIf="shareEmails">
        <app-organization-share-email
          (handleClose)="shareEmails = false"
        ></app-organization-share-email>
      </ng-container>

      <ng-container *ngIf="shareSMS">
        <app-organization-share-sms
          (handleClose)="shareSMS = false"
        ></app-organization-share-sms>
      </ng-container>
    </div>
  </div>
</app-shared-modal>
